// ============================================================================
// uzenetAblak.js — a megjelenített üzenetlista összeállítása: az élő ablak
// (a legutolsó 50 üzenet, folyamatosan figyelve) és a régebbi, egyszer
// betöltött lapok.
//
// MIÉRT KELL: korábban szobánként CSAK a legutolsó 50 üzenet volt elérhető;
// a régebbiekhez nem lehetett visszagörgetni (a specifikáció lapozást ír
// elő). Két dologra kell figyelni:
//   1. a régebbi lap az élő ablak ELÉ kerül, ismétlés nélkül;
//   2. amikor új üzenet jön, az élő ablak legrégebbi eleme "kicsúszik" a
//      figyelésből - annak a képernyőn maradnia kell, különben a lista
//      közepén rés keletkezne (vagy a felhasználó szeme előtt tűnne el).
//
// Tiszta logika, Firebase és DOM nélkül - Node-ban tesztelhető.
// ============================================================================

function egyedi(lista, kizart) {
  const latott = new Set(kizart);
  const eredmeny = [];
  for (const m of lista) {
    if (!m || !m.messageId || latott.has(m.messageId)) continue;
    latott.add(m.messageId);
    eredmeny.push(m);
  }
  return eredmeny;
}

/**
 * Új élő ablak érkezett: a kicsúszott üzenetek a régebbiek közé kerülnek.
 *
 * @param {object[]} regebbi a már betöltött régebbi üzenetek (időrendben)
 * @param {object[]} elozoElo az előző élő ablak (időrendben)
 * @param {object[]} ujElo az új élő ablak (időrendben)
 * @returns {{regebbi: object[], megjelenitett: object[]}}
 */
export function eloAblakFrissitese(regebbi, elozoElo, ujElo) {
  const ujIdk = new Set(ujElo.map((m) => m.messageId));
  const kicsuszott = elozoElo.filter((m) => !ujIdk.has(m.messageId));
  const ujRegebbi = egyedi([...regebbi, ...kicsuszott], ujIdk);
  return { regebbi: ujRegebbi, megjelenitett: [...ujRegebbi, ...ujElo] };
}

/**
 * Egy régebbi lap hozzáadása (az eddigiek ELÉ).
 * @returns {{regebbi: object[], megjelenitett: object[]}}
 */
export function regebbiLapHozzaadasa(regebbi, lap, elo) {
  const eloIdk = new Set(elo.map((m) => m.messageId));
  const ujRegebbi = egyedi([...lap, ...regebbi], eloIdk);
  return { regebbi: ujRegebbi, megjelenitett: [...ujRegebbi, ...elo] };
}
